export default __webpack_public_path__ + "static/media/tw.24a1665c.svg";